<app-sales-person-dashboard-subheader/>
<div>
  <div class="details-content container-fluid h-100">
    <div class="row h-100">
      <div class="col-content d-flex flex-column h-100">
        <div class="page-container container-fluid">
          <div class="card card-light w-100">
            <div class="card-body">
              <div class="container-fluid">
                @if (data$ | async; as data) {
                  <div class="row">
                    <div class="col col-md">
                      <div class="table-wrapper">
                        <table class="table table-striped collapsed-rounded-table">
                          <thead>
                          <tr>
                            <th translate>DASHBOARD_SALESPERSON_LBL_NAME</th>
                            <th class="custom-width-175 text-end" translate>DASHBOARD_SALESPERSON_LBL_CONTRACT_REQUEST
                            </th>
                            <th class="custom-width-175 text-end" translate>
                              DASHBOARD_SALESPERSON_LBL_WAITING_VALIDATION
                            </th>
                            <th class="custom-width-175 text-end" translate>DASHBOARD_SALESPERSON_LBL_OPEN</th>
                            <th class="custom-width-175 text-end" translate>DASHBOARD_SALESPERSON_LBL_TOTAL</th>
                          </tr>
                          </thead>
                          <tbody>
                            @for (rowReport of data.commissionReportSalesPersonProductionDashboardAmountModels; track rowReport.id; let last = $last) {
                              <tr [class]='last ? "fw-bolder" : ""'>
                                <td>{{ rowReport.name }}</td>
                                <td
                                  class="text-end color-contract-status-contract-request">{{ rowReport.contractRequestAmount | showSignValueType: 'Monetary' }}
                                </td>
                                <td
                                  class="text-end color-contract-status-waiting-validation">{{ rowReport.waitingValidationAmount | showSignValueType: 'Monetary' }}
                                </td>
                                <td
                                  class="text-end color-contract-status-open">{{ rowReport.openAmount | showSignValueType: 'Monetary' }}
                                </td>
                                <td class="text-end">{{ rowReport.totalAmount | showSignValueType: 'Monetary' }}</td>
                              </tr>
                            }
                          <tr>
                            <td></td>
                            <td class="text-end">
                              <button type='button' class="link-primary border-0 bg-transparent"
                                      (click)="onSmartLinkClick(this.smartAction, data.contractRequestFilter)"
                                      translate>DASHBOARD_SALESPERSON_LBL_LINK_CONTRACT
                              </button>
                            </td>
                            <td class="text-end">
                              <button type='button' class="link-primary border-0 bg-transparent"
                                      (click)="onSmartLinkClick(this.smartAction, data.waitingValidationFilter)"
                                      translate>DASHBOARD_SALESPERSON_LBL_LINK_CONTRACT
                              </button>
                            </td>
                            <td class="text-end">
                              <button type='button' class="link-primary border-0 bg-transparent"
                                      (click)="onSmartLinkClick(this.smartAction, data.openFilter)"
                                      translate>DASHBOARD_SALESPERSON_LBL_LINK_CONTRACT
                              </button>
                            </td>
                            <td></td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        <app-sales-person-production-dashboard-chart/>
      </div>
    </div>
  </div>
</div>
